import LocalStore from "../../../utilities/local-store-manager";
import BaseProxy from "../../base-proxy";

/**
 * @class ResourceAllocationProxy
 * @description Class used for communicating with resource allocation API.
 * @author Jay Turla
 * @version 1.0
 * @since May 25, 2023
 */
export default class ResourceAllocationProxy {
  /**
   * @async
   * @function execute
   * @param body - Input parameter instance.
   */
  async execute(body = new FormData()) {
    let baseProxy = new BaseProxy();
    let localStore = new LocalStore();
    let authToken = localStore.getToken();
    if (!authToken) {
      return [];
    }
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/companies/${body.companyId}/company-resource-allocation`;

    return await baseProxy.getAuthenticatedData(endpointUrl, authToken);
  }
}
